import { createSharedPathnamesNavigation } from 'next-intl/navigation';

// Use a static array instead of dynamic evaluation for Edge compatibility
// MUST match the middleware.ts configuration
export const locales = ['es', 'en']; // Add all supported locales statically
export const localePrefix = 'always'; // MUST match middleware.ts

export const {
  Link,
  redirect,
  usePathname,
  useRouter
} = createSharedPathnamesNavigation({
  locales,
  localePrefix
});